<clr-modal [(clrModalOpen)]="displayError" [clrModalClosable]="false" [clrModalStaticBackdrop]="true">
  <h3 class="modal-title">An error occurred!</h3>
  <div class="modal-body">
    <p>{{ errorMessage }}</p>
  </div>
</clr-modal>
